import React from "react";

import { Link } from "react-router-dom";

const Sidebar = () => {
    return (
        <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">


            <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/admin">
                <div className="sidebar-brand-icon rotate-n-15">
                    <i className="fas fa-laugh-wink"></i>
                </div>
                <div className="sidebar-brand-text mx-3">SB Admin <sup>2</sup></div>
            </Link>


            <hr className="sidebar-divider my-0" />


            <li className="nav-item active">
                <Link className="nav-link" to="/admin/dashboard">
                    <i className="fas fa-fw fa-tachometer-alt"></i>
                    <span>Dashboard</span>
                </Link>
            </li>

            <li className="nav-item">
                <Link className="nav-link collapsed" to="#" data-toggle="collapse" data-target="#categoriesMenu"
                    aria-expanded="true" aria-controls="categoriesMenu">
                    <i className="fas fa-box-open fa-fw"></i>
                    <span>Categories</span>
                </Link>
                <div id="categoriesMenu" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                    <div className="bg-white py-2 collapse-inner rounded">
                        <Link className="collapse-item" to="/admin/add-category">Add Category</Link>
                        <Link className="collapse-item" to="/admin/view-categories">View Categories</Link>
                    </div>
                </div>
            </li>

            <li className="nav-item">
                <Link className="nav-link collapsed" to="#" data-toggle="collapse" data-target="#productsMenu"
                    aria-expanded="true" aria-controls="productsMenu">
                    <i className="fas fa-shopping-cart fa-fw"></i>
                    <span>Products</span>
                </Link>
                <div id="productsMenu" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                    <div className="bg-white py-2 collapse-inner rounded">
                        <Link className="collapse-item" to="/admin/add-product">Add Product</Link>
                        <Link className="collapse-item" to="/admin/view-products">View Products</Link>
                    </div>
                </div>
            </li>
            
            <li className="nav-item">
                <Link className="nav-link" to="/admin/orders">
                    <i className="fas fa-fw fa-user"></i>
                    <span>Orders</span>
                </Link>
            </li>

            <li className="nav-item">
                <Link className="nav-link" to="/admin/profile">
                    <i className="fas fa-fw fa-user"></i>
                    <span>Profile</span>
                </Link>
            </li>

            <li className="nav-item">
                <Link className="nav-link" to="/admin/404">
                    <i className="fas fa-fw fa-user"></i>
                    <span>404</span>
                </Link>
            </li>


            <hr className="sidebar-divider" />

            

            <hr className="sidebar-divider" />


            <div className="text-center d-none d-md-inline">
                <button className="rounded-circle border-0" id="sidebarToggle"></button>
            </div>

        </ul>
    );
}

export default Sidebar;